import { render, staticRenderFns } from "./RelAdminRadar.vue?vue&type=template&id=cdb5a36a&scoped=true"
import script from "./RelAdminRadar.vue?vue&type=script&lang=js"
export * from "./RelAdminRadar.vue?vue&type=script&lang=js"
import style0 from "./RelAdminRadar.vue?vue&type=style&index=0&id=cdb5a36a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb5a36a",
  null
  
)

export default component.exports